









import CoLabel from '../../Atoms/co-label/CoLabel.vue';

export default {
    name: 'CoFormGroup',
    components: { CoLabel },

    props: {
        label: {
            type: String,
            default: '',
            required: false,
        },
        labelType: {
            type: String,
            default: 'p2',
            required: false,
            validator(value: string) {
                return ['p1', 'p2'].includes(value);
            },
        },
    },
    data() {
        return {};
    },
};
